import { Component, OnInit, Input } from '@angular/core';
import { FindInspectionService } from '../../services/find-inspection.service';
import { InspectionRowViewModel } from '../../models/find-inspection.model';
import { Router } from '@angular/router';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'inspection-list-row',
  templateUrl: './inspection-list-row.component.html',
  styleUrls: ['./inspection-list-row.component.scss'],
  animations: [
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )]
})
export class InspectionListRowComponent implements OnInit {
  @Input() inspectionId: number;
  public inspection: InspectionRowViewModel;
  public loadingRow: boolean = true;

  constructor(private _findInspection: FindInspectionService,
  private _router: Router) { }

  ngOnInit() {
    this.loadRowData();
  }

  loadRowData() {
    this._findInspection.getInspectionRow(this.inspectionId).subscribe(r => {
      this.inspection = r;
      this.loadingRow = false;
    });
  }

  openInspection() {
    switch (this.inspection.Family) {
      case "Rope Shovel":
        // this._router.navigate(['/rs-inspection', this.inspectionId]);
        window.open('/rs-inspection/' + this.inspectionId, '_blank');
        break;
      default:
        // this._router.navigate(['/interpretation', this.inspectionId]);
        window.open('/interpretation/' + this.inspectionId, '_blank');
        break;
    }
  }
}
